// extracted by mini-css-extract-plugin
module.exports = {"buttonsContainer":"OnGoingPaymentBox_buttonsContainer__1uMO2","resendInfoText":"OnGoingPaymentBox_resendInfoText__BpgSC"};